import React from 'react';
import classNames from 'classnames';
import classes from './block.scss';
const Block = props => {
  const rootClass = classNames(classes.block, props.className);
  return /*#__PURE__*/React.createElement("div", {
    className: rootClass,
    "data-block": props.dataBlock
  }, props.children);
};
export default Block;